import React, {useState, useEffect, useRef} from 'react'
import documentationIcon from "../../common/assets/images/documentation.png";
import searchIcon from "../../common/assets/images/Search.png";
import {Accordion, Card, Pagination, Spinner} from "react-bootstrap";
import plusIcon from "../../common/assets/images/plus_icon.png";
import minsIcon from "../../common/assets/images/mins-icon.png";
import externalIcon from "../../common/assets/images/link-external.png";
import LdsRoller from "../../utils/LdsRoller";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import DOMPurify from 'dompurify';
import { getDocumentViewerData, searchDocumentViewerData, setDocumentviewerPage, setDocumentviewerSearchValue, setDocumentviewerEventKey, setDocumentviewerSelectedDocumentData } from "./redux/DocumentViewerSlicer";

const DocumentViewerWindow = () => {
  const cardRefs = useRef([]);
  const location = useLocation();
  const dispatch = useDispatch();
  const storedData = sessionStorage.getItem('documentViewerData');
  const { documentviewerCurrentPage, documentviewerSearchValue, documentviewerEventKey, documentviewerSelectedDocumentData, episodeIdentifierTopassDocumentViewer } = useSelector((state) => state.documentViewer);
  const { documentViewerData, documentViewerDataLoader, documentViewerDataError } = useSelector((state) => state.documentViewer.documentViewer);
  const storageData = JSON.parse(storedData);
  const filteredDocumentsList = documentViewerData?.documents?.length > 0 ? documentViewerData.documents.filter((item) => item?.document_name?.replace(".txt", "")?.slice(item?.document_name?.indexOf("-") + 1) === storageData?.documentName) : [];
  const [documentviewerRowsPerPage, setDocumentviewerRowsPerPage] = useState(5);
  // const totalPages = Math.ceil(documentViewerData?.total_documents / documentviewerRowsPerPage);
  const totalDocuments = Number(documentViewerData?.total_documents) || 0;
  const currentPage = Number(documentviewerCurrentPage);
  const rowsPerPage = Number(documentviewerRowsPerPage);
  const isValid = Number.isFinite(currentPage) && Number.isFinite(rowsPerPage) && currentPage > 0 && rowsPerPage > 0;
  const start = isValid ? (currentPage - 1) * rowsPerPage + 1 : '-';
  const end = isValid ? Math.min(currentPage * rowsPerPage, totalDocuments) : '-';
  const totalPages = documentViewerData?.total_documents ? Math.ceil(documentViewerData.total_documents / documentviewerRowsPerPage) : 0;

  const [documentViewerEpisodeIdentifier, setDocumentViewerEpisodeIdentifier] = useState("");
  const [documentviewerNewCurrentPage, setDocumentviewerNewCurrentPage] = useState(1)
  const [documentviewerNewEventKey, setDocumentviewerNewEventKey] = useState(null)
  const [documentviewerNewSearchValue, setDocumentviewerNewSearchValue] = useState(null);
  const [documentViewerNewDocumentName, setDocumentViewerNewDocumentName] = useState("");
   const [aiJustificationDocumentName, setAiJustificationDocumentName] = useState(null);
  const [aiJustificationEvidence, setAiJustificationEvidence] = useState(null);

     useEffect(() => {
      if (storedData) {
        const documentViewerWindowStroageData = JSON.parse(storedData);
        if(documentViewerWindowStroageData.episode_identifier_number !== undefined){
          dispatch(getDocumentViewerData({
            documentEpisodeIdentifier: documentViewerWindowStroageData.episode_identifier_number,
            documentCurrentPage: documentViewerWindowStroageData.page,
          }));
        }
        setDocumentViewerEpisodeIdentifier(documentViewerWindowStroageData.episode_identifier_number)
        setDocumentviewerNewCurrentPage(documentViewerWindowStroageData.page)
        setDocumentviewerNewEventKey(documentViewerWindowStroageData.eventKey)
        setDocumentviewerNewSearchValue(documentViewerWindowStroageData.searchValue)
        setDocumentViewerNewDocumentName(documentViewerWindowStroageData.documentName)
         setAiJustificationDocumentName(documentViewerWindowStroageData.aiJustificationDocumentName ?? null);
      setAiJustificationEvidence(documentViewerWindowStroageData.aiJustificationEvidence ?? null);
      } else {
        console.log('No data found in parent window.');
      }
    }, []);


    const handleDocumentViewerPageChange = (pageNumber) => {
      if (pageNumber > 0 && pageNumber <= documentViewerData?.total_documents) {
        const selectedData = {
          ...documentviewerSelectedDocumentData,
          documentID: null, 
        };
        dispatch(setDocumentviewerSelectedDocumentData(selectedData));
        const sessionData = storedData ? JSON.parse(storedData) : {}; 
        const updatedData = {
          ...sessionData,
          page: pageNumber,
        };
        sessionStorage.setItem("documentViewerData", JSON.stringify(updatedData));
        dispatch(setDocumentviewerEventKey(null));
        setDocumentviewerNewEventKey(null)
        dispatch(setDocumentviewerPage(pageNumber));
        setDocumentviewerNewCurrentPage(pageNumber)
        dispatch(getDocumentViewerData({documentEpisodeIdentifier: documentViewerEpisodeIdentifier, documentCurrentPage: pageNumber}));
      }
    };
    

      const checkCardHeight = (index) => {
        const sessionData = storedData ? JSON.parse(storedData) : {};
        const documentsDocumentCategoryId = filteredDocumentsList?.length > 0 ? filteredDocumentsList?.map((item) => item.document_patient_document_id) : [];
        const minDocumentID  = Math.min(...documentsDocumentCategoryId)
        const maxDocumentID  = Math.max(...documentsDocumentCategoryId)
        const currentCardBody = cardRefs.current[index];
        if (currentCardBody) {
          let scrollPosition = Math.floor(currentCardBody.scrollTop);
          const cardHeight = currentCardBody.clientHeight;
          const cardContentHeight = currentCardBody.scrollHeight;
          if (location.pathname === "/document-viewer" || true) {
            const currentDocumentIndex = documentsDocumentCategoryId.indexOf(index);
            // console.log(scrollPosition + cardHeight, cardContentHeight, 'scrollPosition')
            if (scrollPosition + cardHeight >= cardContentHeight - 1) { 

            const newDocumentIndex  = documentsDocumentCategoryId[currentDocumentIndex + 1]
              if (newDocumentIndex >= minDocumentID) {
                // setEventKey(newDocumentIndex);
                const updatedData = {
                  ...sessionData,
                  eventKey: newDocumentIndex,
                };
                sessionStorage.setItem("documentViewerData", JSON.stringify(updatedData));
                dispatch(setDocumentviewerEventKey(newDocumentIndex));
                setDocumentviewerNewEventKey(newDocumentIndex);
                const selectedData = {
                  ...documentviewerSelectedDocumentData,
                  documentID: newDocumentIndex,
                }
                dispatch(setDocumentviewerSelectedDocumentData(selectedData))
                // setSelectedDocumentData((prev) => ({
                //   ...prev,
                //   documentID: newDocumentIndex,
                // }));
              }
            } else if (scrollPosition <= 0) {
              const newDocumentPrevIndex  = documentsDocumentCategoryId[currentDocumentIndex - 1]
              // console.log(newDocumentPrevIndex, 'newDocumentPrevIndex')
                if (newDocumentPrevIndex <= maxDocumentID) { 
                  const updatedData = {
                    ...sessionData,
                    eventKey: newDocumentPrevIndex,
                  };
                  sessionStorage.setItem("documentViewerData", JSON.stringify(updatedData));
                  dispatch(setDocumentviewerEventKey(newDocumentPrevIndex));
                  setDocumentviewerNewEventKey(newDocumentPrevIndex)
                const selectedData = {
                  ...documentviewerSelectedDocumentData,
                  documentID: newDocumentPrevIndex,
                }
                dispatch(setDocumentviewerSelectedDocumentData(selectedData))
                }
              }
            }
          } else {
            console.log('No card found');
          }
        };

    const documentSelectedHandler = (documentData) => {
       const params = new URLSearchParams(window.location.search);
    const newEpisodeIdentifier = params.get("episode_identifier_number");

    const episode_identifier_to_pass = episodeIdentifierTopassDocumentViewer
      ? episodeIdentifierTopassDocumentViewer
      : newEpisodeIdentifier;
      const data = {
        // documentName: documentData.document_name?.toLowerCase()?.replace(/\.txt/g, ""),
        // documentName: documentData.document_name?.slice(documentData.document_name.indexOf("-") + 1),
        documentName:documentData?.document_name?.replace(".txt", "")?.slice(documentData?.document_name?.indexOf("-") + 1).replaceAll("_", " "),
        eventKey: documentviewerNewEventKey ? documentviewerNewEventKey : null,
        searchValue: documentviewerNewSearchValue ? documentviewerNewSearchValue : "",
        episode_identifier_number: episode_identifier_to_pass,
        page: documentviewerNewCurrentPage ? documentviewerNewCurrentPage : 1,
        aiJustificationDocumentName: aiJustificationDocumentName ?? null,
      aiJustificationEvidence: aiJustificationEvidence ?? null,
      };
       window.open('/document-viewer', '_blank');
      sessionStorage.setItem('documentViewerData', JSON.stringify(data));
    };

 const documentSearchHandler = (event) => {
  const sessionData = storedData ? JSON.parse(storedData) : {}; 

  const value = event.target.value
  const updatedData = {
    ...sessionData,
    searchValue: value,
  };
  sessionStorage.setItem("documentViewerData", JSON.stringify(updatedData));
    dispatch(setDocumentviewerSearchValue(value));
    setDocumentviewerNewSearchValue(value);
  };

  
    const toggleAccordion = (id) => {
      const sessionData = storedData ? JSON.parse(storedData) : {}; 
      
      const updatedData = {
        ...sessionData,
        eventKey: id,
      };
      sessionStorage.setItem("documentViewerData", JSON.stringify(updatedData));
      const newID = id === documentviewerNewEventKey ? null : id
      dispatch(setDocumentviewerEventKey(newID));
      setDocumentviewerNewEventKey(newID)
    };


    const addTooltipToSpans = (reasoningContent, documentCodes) => {
      return reasoningContent?.replace(/(<span[^>]*>)/g, (text) => {
        return text.replace('<span', `<span data-tooltip=${documentCodes}`);
      });
    };
    // ---- Redaction highlighting ----
  const REDACTED_PATTERN = /\[\s*REDACTED[^\]]*\]/gi;
  const REDACTED_PATTERN_TEST = /\[\s*REDACTED[^\]]*\]/i;

  const highlightRedactedText = (html) => {
    if (!html) return html;
    return html.replace(
      REDACTED_PATTERN,
      (match) => `<span class="document-redacted-highlight">${match}</span>`
    );
  };

  // ---- AI evidence highlighting (with search on top) ----
  const highlightEvidenceText = (documentText, evidence, searchTerm) => {
    if (!documentText || !evidence) {
      return documentText;
    }

    const cleanedEvidence = evidence
      .replace(/\\n/g, "\n")
      .replace(/\*\*/g, "")
      .replace(/\\+$/g, "")
      .trim();

    const evidenceParts = cleanedEvidence
      .split(/\r?\n/)
      .map((text) => text.trim())
      .map((text) => text.replace(/^["'“”‘’]+|["'“”‘’]+$/g, "").trim())
      .filter(
        (text) => text && text !== "..." && text.length > 2 && !REDACTED_PATTERN_TEST.test(text)
      );

    let result = documentText;

    evidenceParts.forEach((evidencePart) => {
      const normalizedEvidence = evidencePart.replace(/\s+/g, " ").trim();
      if (!normalizedEvidence) return;

      const escapedEvidence = normalizedEvidence.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const flexiblePattern = escapedEvidence.replace(/\s+/g, "(?:\\s|\\\\n|<br\\s*/?>)+");
      const regex = new RegExp(`(${flexiblePattern})`, "gi");

      result = result.replace(regex, `<span class="ai-evidence-highlight">$1</span>`);
    });

    result = highlightRedactedText(result);

    if (searchTerm && searchTerm.trim() !== "") {
      const div = document.createElement("div");
      div.innerHTML = result;
      const textNodes = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const parts = node.textContent.split(new RegExp(`(${searchTerm})`, "gi"));
          const fragment = document.createDocumentFragment();
          parts.forEach((part) => {
            if (part.toLowerCase() === searchTerm.toLowerCase()) {
              const span = document.createElement("span");
              span.style.backgroundColor = "lightgreen";
              span.textContent = part;
              fragment.appendChild(span);
            } else {
              fragment.appendChild(document.createTextNode(part));
            }
          });
          node.replaceWith(fragment);
        } else {
          node.childNodes.forEach(textNodes);
        }
      };
      textNodes(div);
      result = div.innerHTML;
    }

    return result;
  };

  
    const highlightText = (documentText, searchTerm) => {
      // const text = documentText.replace(/\r\n|\r|\n/g, "<br />");
      // if (!searchTerm) return text; 
      // const parts = text.split(new RegExp(`(${searchTerm})`, 'gi')); 
      
      // return parts.map((part, index) =>
      //   part.toLowerCase() === searchTerm.toLowerCase() ? (
      //     <span key={index} style={{ backgroundColor: 'yellow' }}>{part}</span>
      //   ) : (
      //     part
      //   )
      // );
  
      if (!searchTerm) return documentText;
      const div = document.createElement('div');
      div.innerHTML = documentText;
      const textNodes = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const parts = node.textContent.split(new RegExp(`(${searchTerm})`, 'gi'));
    
          const fragment = document.createDocumentFragment();
          parts.forEach((part, index) => {
            if (part.toLowerCase() === searchTerm.toLowerCase()) {
              const span = document.createElement('span');
              span.style.backgroundColor = 'lightgreen';
              span.textContent = part;
              fragment.appendChild(span);
            } else {
              fragment.appendChild(document.createTextNode(part));
            }
          });
    
          node.replaceWith(fragment);
        } else {
          node.childNodes.forEach(textNodes);
        }
      };
    
      textNodes(div);
    
      return div.innerHTML;
    };
    const highlightHtmlText = (html, documentData, searchTerm) => {
    let document_codes = documentData.reasonings.map((item) => item.document_codes).reverse();
    let counter = 0;

    const updatedText = html.replace(/<span(.*?)style=['"](.*?background-color:.*?)['"](.*?)>/g, (match, p1, p2, p3) => {
      const documentCode = document_codes[counter % document_codes.length];
      counter++;
      return `<span${p1} style='${p2}' data-tooltip='${documentCode}' ${p3}>`;
    });

    if (!searchTerm) return highlightRedactedText(updatedText);
    const div = document.createElement('div');
    div.innerHTML = updatedText;
    const textNodes = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const parts = node.textContent.split(new RegExp(`(${searchTerm})`, 'gi'));
        const fragment = document.createDocumentFragment();
        parts.forEach((part) => {
          if (part.toLowerCase() === searchTerm.toLowerCase()) {
            const span = document.createElement('span');
            span.style.backgroundColor = 'lightgreen';
            span.textContent = part;
            fragment.appendChild(span);
          } else {
            fragment.appendChild(document.createTextNode(part));
          }
        });
        node.replaceWith(fragment);
      } else {
        node.childNodes.forEach(textNodes);
      }
    };
    textNodes(div);
    return highlightRedactedText(div.innerHTML);
  };
  
    // const highlightHtmlText = (html, documentData, searchTerm) => {

    //   let document_codes = documentData.reasonings.map((item) => item.document_codes).reverse();
    //   let counter = 0;
      
    //   const updatedText = html.replace(/<span(.*?)style=['"](.*?background-color:.*?)['"](.*?)>/g, (match, p1, p2, p3) => {
    //     const documentCode = document_codes[counter % document_codes.length];  
    //     counter++;
      
    //     return `<span${p1} style='${p2}' data-tooltip='${documentCode}' ${p3}>`;
    //   });

    //   if (!searchTerm) return updatedText;
    //   const div = document.createElement('div');
    //   div.innerHTML = updatedText;
    //   const textNodes = (node) => {
    //     if (node.nodeType === Node.TEXT_NODE) {
    //       const parts = node.textContent.split(new RegExp(`(${searchTerm})`, 'gi'));
    
    //       const fragment = document.createDocumentFragment();
    //       parts.forEach((part, index) => {
    //         if (part.toLowerCase() === searchTerm.toLowerCase()) {
    //           const span = document.createElement('span');
    //           span.style.backgroundColor = 'yellow';
    //           span.textContent = part;
    //           fragment.appendChild(span);
    //         } else {
    //           fragment.appendChild(document.createTextNode(part));
    //         }
    //       });
    
    //       node.replaceWith(fragment);
    //     } else {
    //       node.childNodes.forEach(textNodes);
    //     }
    //   };
    
    //   textNodes(div);
    
    //   return div.innerHTML
    // };  

  return (
    <div className="document-viewer-window-section">
    <div className="documentation-card-header">
      <p className="documentation-header-text">Documentation</p>
      <div>
        {/* <a
                                                          onClick={(e) => {
                                                            const dataToSend = {
                                                              episode_identifier: documentViewerEpisodeIdentifier,
                                                              page: documentviewerNewCurrentPage,
                                                            }
                                                            sessionStorage.setItem('dataToSend', JSON.stringify(dataToSend));
                                                            window.open('/document-viewer', '_blank');
                                                          }}
                                                          className="documentation-externalLink-btn"
                                                          >
                                                          <img src={externalIcon} alt="External Link" />
                                                        </a> */}
      <span className="documentation-header-icon">
        <img src={documentationIcon} alt="doc" />
      </span>
      </div>
    </div>
    <div className="document-viewer-window-search">
      <span className="document-viewer-search-icon">
        <img className="document-viewer-search-img" src={searchIcon} />
      </span>
      <input
        className="document-viewer-search-input"
        placeholder="Search"
        autoComplete="off"
        name="documentviewerNewSearchValue"
        value={documentviewerNewSearchValue}
        onChange={documentSearchHandler}
      />
    </div>
    <div className="document-viewer-accordion-section">
      {documentViewerDataLoader ? (
        <div className="document-viewer-loader">
          <LdsRoller />{" "}
        </div>
      ) : documentViewerDataError ? (
        <div className="document-viewer-error">
          <p>{documentViewerDataError}</p>
        </div>
      ) : (
        <Accordion
          className="document-viewer-accordion-container"
          activeKey={documentviewerNewEventKey}
        >
          {filteredDocumentsList?.length > 0 ? (
            filteredDocumentsList?.map((documentData, index) => {
              const isAIDocument =
                  aiJustificationDocumentName &&
                  documentData?.document_name === aiJustificationDocumentName;

              return(
              <Card
                key={documentData.document_patient_document_id}
                className="document-viewer-container-accordion-card"
              >
                <Card.Header className="document-viewer-accordion-header">
                  <div className="document-accordion-section">
                    <div className="document-viewer-btn">
                      {/* {
                      documentData.document_name?.slice(documentData.document_name.indexOf("-") + 1)
                     } */}
                     {documentData?.document_name?.replace(".txt", "")?.slice(documentData?.document_name?.indexOf("-") + 1).replaceAll("_", " ")}
                    {/* {documentViewerEpisodeIdentifier !== undefined
                            ? documentData.document_name
                                ?.toLowerCase()
                                ?.replace(/\.txt/g, "")
                                ?.slice(
                                  documentViewerEpisodeIdentifier?.length +
                                    1
                                )
                            : documentData.document_name
                                ?.toLowerCase()
                                ?.replace(/\.txt/g, "")
                                ?.slice(
                                  documentViewerEpisodeIdentifier?.length + 1
                                )} */}
                    </div>
                    <div>
                      {documentviewerNewEventKey ===
                      documentData?.document_patient_document_id ? (
                        <div>
                          <a
                            onClick={(e) =>
                              documentSelectedHandler(documentData)
                            }
                            className="externalLink-btn"
                          >
                            <img src={externalIcon} alt="External Link" />
                          </a>
                          <button
                            className="document-accordion-minus-icon"
                            onClick={() =>
                              toggleAccordion(
                                documentData?.document_patient_document_id
                              )
                            }
                          >
                            <img src={minsIcon} alt="-" />
                          </button>
                        </div>
                      ) : (
                        <div className="accordion-header-btn">
                          <button
                            className="document-accordion-plus-icon"
                            onClick={() => {
                              toggleAccordion(
                                documentData?.document_patient_document_id
                              );
                              const selectedData = {
                                documentID: documentData?.document_patient_document_id,
                                documentContent: documentData?.document_text,
                                documentName: documentData.document_name
                              }
                              dispatch(setDocumentviewerSelectedDocumentData(selectedData))
                            }}
                          >
                            <img src={plusIcon} alt="+" />
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </Card.Header>
                <Accordion.Collapse
                  eventKey={documentData?.document_patient_document_id}
                  // ref={(el) =>
                  //   (cardRefs.current[
                  //     documentData?.document_patient_document_id
                  //   ] = el)
                  // }
                  // onScrollCapture={() =>
                  //   checkCardHeight(
                  //     documentData?.document_patient_document_id
                  //   )
                  // }
                >
                  <Card.Body
                    className="document-viewer-window-accordion-card-body"
                    ref={(el) => (cardRefs.current[documentData?.document_patient_document_id] = el)}
                    onScroll={() => checkCardHeight(documentData?.document_patient_document_id)}
                  >
                    {documentData?.document_coloured_text !== null ? (
                  <div className="document-viewer-accordion-text"
                     dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                isAIDocument
                                  ? highlightEvidenceText(
                                      documentData?.document_coloured_text.replace(/\r\n|\r|\n/g, "<br />"),
                                      aiJustificationEvidence,
                                      documentviewerNewSearchValue
                                    )
                                  : highlightHtmlText(
                                      documentData?.document_coloured_text.replace(/\r\n|\r|\n/g, "<br />"),
                                      documentData,
                                      documentviewerNewSearchValue
                                    )
                              ),
                            }}
                  ></div>
                ) : (
                <div className="document-viewer-accordion-text">
                  <span 
                    dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                  isAIDocument
                                    ? highlightEvidenceText(
                                        documentData?.document_text.replace(/\r\n|\r|\n/g, "<br />"),
                                        aiJustificationEvidence,
                                        documentviewerNewSearchValue
                                      )
                                    : highlightText(
                                        documentData?.document_text.replace(/\r\n|\r|\n/g, "<br />"),
                                        documentviewerNewSearchValue
                                      )
                                ),
                              }}
                    ></span>
                  {/* {highlightText(documentData?.document_text, documentviewerNewSearchValue)} */}
                </div>
          )}
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            )
            })
            
          ) : (
            <p className="document-no-data-found">
              No matching documents found.
            </p>
          )}
        </Accordion>
      )}
      {/* Reasoning Accordion */}
      {/* {! documentViewerDataLoader &&  filteredDocumentsList?.length > 0 && <Accordion
                className="document-viewer-accordion-reasoning-container"
                activeKey={documentviewerNewEventKey}
              >
                <Card className="document-viewer-accordion-reasoning-card">
                  <Card.Header className="document-viewer-accordion-reasoning-header">
                    <div className="document-accordion-section">
                      <div className="document-viewer-reasoning-btn">Reasoning​</div>
                      <div>
                        {documentviewerNewEventKey !== null ? (
                          <div>
                            <button
                              className="document-accordion-minus-icon"
                              onClick={() =>
                                toggleAccordion(documentviewerNewEventKey)
                              }
                            >
                              <img src={minsIcon} alt="-" />
                            </button>
                          </div>
                        ) : (
                          <div className="accordion-header-btn">
                            <button
                              className="document-accordion-plus-icon"
                              onClick={() => {
                                toggleAccordion(
                                  documentviewerNewEventKey
                                );
                              }}
                            >
                              <img src={plusIcon} alt="+" />
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </Card.Header>
                  {documentviewerNewEventKey !== null && (
                    <Accordion.Collapse
                      eventKey={documentviewerNewEventKey}
                    >
                      <Card.Body className="document-viewer-accordion-reasoning-window-card-body">
  
                        {filteredDocumentsList
                          ?.filter(
                            (item) =>
                              item.document_patient_document_id ===
                            documentviewerNewEventKey
                          )
                          ?.map((item) =>
                            item.reasonings.length > 0 ? item.reasonings.map((reasoningsData) => (
                              <>
                                <span className="document-viewer-reasoning-name">
                                  {reasoningsData.group}:
                                </span>
                                <div key={reasoningsData?.reasoning_id}>
                                  <div
                                    className="document-viewer-reasoning-text"
                                    dangerouslySetInnerHTML={{
                                      __html: addTooltipToSpans(
                                        reasoningsData
                                          .document_coloured_reasoning_content
                                          ?.length > 0
                                          ? reasoningsData.document_coloured_reasoning_content
                                          : reasoningsData.document_reasoning_content, reasoningsData.document_codes
                                      ),
                                    }}
                                  />
                                </div>
                              </>
                            )) :  <p className="document-viewer-reasoning-text-no-data">No reasonings found</p>
                          )}
                      </Card.Body>
                    </Accordion.Collapse>
                  )}
                </Card>
              </Accordion>
              } */}
    </div>
    
  </div>
  )
}

export default DocumentViewerWindow



// <Pagination className="document-viewer-window-pagination">
      // <Pagination.Prev
        // onClick={() =>
          // handleDocumentViewerPageChange(documentviewerNewCurrentPage - 1)
        // }
        // disabled={documentviewerNewCurrentPage === 1}
        // className="document-viewe-prev-btn"
      // />
            // {`Showing ${start} - ${end} of ${totalDocuments}`}
        {/* {(() => {
            const start = (documentviewerNewCurrentPage - 1) * documentviewerRowsPerPage + 1;
            const end = Math.min(documentviewerNewCurrentPage * documentviewerRowsPerPage, documentViewerData?.total_documents);
            return `showing ${start}-${end} of ${documentViewerData?.total_documents}`;
})()} */}
      // <Pagination.Next
        // onClick={() => handleDocumentViewerPageChange(documentviewerNewCurrentPage + 1)} disabled={ documentviewerNewCurrentPage === totalPages || totalPages === 0}
        // onClick={() => handleDocumentViewerPageChange(documentviewerNewCurrentPage + 1)}
        // disabled={documentviewerNewCurrentPage === totalPages || totalPages === 0}
        // className="document-viewe-next-btn"
      // />
    // </Pagination>